import { api } from "./useApi";
import { TipoVariacao } from "../types/Produto";

export const tiposVariacaoApi = () => ({
  getTipos: async (): Promise<TipoVariacao[]> => {
    let response = await api.post("variacao/tipos");
    return response.data;
  },
  criarTipo: async (nome: string): Promise<TipoVariacao> => {
    let response = await api.post("variacao/tipos_acao/criar", { nome });
    return response.data;
  },
  atualizarTipo: async (id: number, dados: Partial<TipoVariacao>): Promise<TipoVariacao> => {
    let response = await api.post("variacao/tipos_acao/atualizar", { id, ...dados });
    return response.data;
  },
  getSugestoes: async (): Promise<Record<string, string[]>> => {
    let response = await api.post("variacao/sugestoes");
    return response.data;
  },
});
